import { ProjectMember } from '@ih/app/shared/apis/interfaces';

export class RejectProjectMember {
  public static readonly type =
    '[Project/ProjectMember/List] RejectProjectMember';
  constructor(public readonly projectMember: ProjectMember) {}
}
